import {  useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography, IconButton, FormControlLabel, Checkbox } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack';
import { BasicFields } from './zoneTypes/BasicFields';
import Weekdays from './zoneTypes/Weekdays'
import Holiday from './zoneTypes/Holiday';
import ConsecutiveDaysWorked from './zoneTypes/ConsecutiveDaysWorked';
import { DiferencialDaily, DiferencialWeekly } from './zoneTypes/Diferencial';
import Draggable from './common/Draggable';
import UnsavedChangesAlert from './common/UnsavedChangesAlert';
import CloseIcon from '@mui/icons-material/Close';
import { useZone } from './ZoneContext';
import { useZoneActions } from './ZoneContext';
import { useFormValidation } from './validations';
import { createZone, getSectionByType } from './request';

const Add = ({ open, setOpen, reloading, rows }) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const zone = useZone();
    const { updateField, resetForm } = useZoneActions();
    const { hasChanges, isDisabled } = useFormValidation();
    const [alert, setAlert] = useState(false);
    const [loading, setLoading] = useState(false);

    const formComponents = () => {
        return {
            holiday: <Holiday key='holiday' open={open}/>,
            week_days: <Weekdays key='week_days'/>,
            consecutive_days_worked: <ConsecutiveDaysWorked key='consecutive_days_worked' open={open}/>,
            diferential_daily_extend_zone_rule: <DiferencialDaily key='diferential_daily_extend_zone_rule'/>,
            diferential_weekly_extend_daily: <DiferencialWeekly key='diferential_weekly_extend_daily'/>,
        };
    };

    const onClose = () => {
        setOpen(false);
        resetForm();
        setAlert(false);
    }

    const changes = () => {
        hasChanges ? setAlert(true) : onClose();
    }

    const handleSave = async () => {
        setLoading(true);

        try {
            const type = getSectionByType(zone.general.type);
            const { holidays, overtimeSustitutions, ...data } = zone[type];
            console.log('data', data);

            await createZone(zone.general.type, zone.general, data);

            resetForm();
            setOpen(false);
            reloading();
            enqueueSnackbar(t('settings.zones.alerts.add.success'), { variant: 'success' });
        } catch (error) {
            console.error('Error creating zone:', error);
            enqueueSnackbar(t('settings.zones.alerts.add.error'), { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            fullWidth
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    return;
                }
                changes()
            }}
            maxWidth='sm'
            PaperComponent={Draggable}
            aria-labelledby="draggable-dialog-title"
            aria-describedby="draggable-alert-dialog-description"
        >
            <DialogTitle style={{ cursor: 'move' }} id='draggable-dialog-title'>
                <Typography variant='body3'>{t('settings.zones.titles.add')}</Typography>
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => changes()}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <UnsavedChangesAlert
                show={alert}
                onCancel={() => setAlert(false)}
                onConfirm={onClose}
            />
            <DialogContent dividers>
                <BasicFields rows={rows}/>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        {formComponents()[zone.general.type]}
                    </Grid>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={zone.general.requiredApproval}
                                onChange={(event) => updateField('general', 'requiredApproval', event.target.checked)}
                            />
                        }
                        label={t('settings.zones.fields.holiday.requires_approval')}
                    />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose()} color="error" variant='contained'>
                    {t('general.buttons.cancel')}
                </Button>
                <Button
                    color="primary"
                    variant='contained'
                    disabled={isDisabled}
                    onClick={handleSave}
                    loading={loading}
                >
                    {t('general.buttons.save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export { Add };